import { useState, useMemo } from "react";
import Reveal, { SectionLabel } from "../components/Reveal";
import PageHero from "../components/PageHero";
import { GALLERY } from "../lib/site";

const CATS = ["All", "Workshops", "Stage Performances", "Public Speaking Events", "Reading Activities", "Classroom Sessions"];

export default function Gallery() {
  const [active, setActive] = useState("All");
  const items = useMemo(
    () => (active === "All" ? GALLERY : GALLERY.filter((g) => g.cat === active)),
    [active]
  );

  return (
    <>
      <PageHero
        label="Gallery"
        title={<>Moments where voices <em className="font-serif italic gold-text">found themselves</em>.</>}
        subtitle="A glimpse into life at BTSA — the stages, studios, conversations and quiet triumphs that shape our learners."
      />

      <section className="pt-12 pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {/* filter */}
          <div data-testid="gallery-filters" className="flex flex-wrap gap-2 lg:gap-3 border-b border-white/10 pb-7">
            {CATS.map((c) => (
              <button
                key={c}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setActive(c)}
                className={`font-sans text-[11px] tracking-[0.24em] uppercase px-5 py-3 border transition-all duration-300 ${
                  active === c
                    ? "border-[#d4af37] text-black bg-[#d4af37]"
                    : "border-white/15 text-white/70 hover:border-[#d4af37] hover:text-[#d4af37]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {/* masonry-like */}
          <div data-testid="gallery-grid" className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-5 lg:gap-6 [column-fill:_balance]">
            {items.map((g, i) => (
              <Reveal key={i + g.src} delay={(i % 6) * 0.05}>
                <figure
                  data-testid={`gallery-item-${i}`}
                  className="mb-5 lg:mb-6 break-inside-avoid relative overflow-hidden group hairline"
                >
                  <img
                    src={g.src}
                    alt={g.cat}
                    className="w-full h-auto object-cover transition-all duration-[1.2s] group-hover:scale-[1.04] grayscale-[15%] group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
                  <figcaption className="absolute bottom-4 left-5 right-5 flex justify-between items-end">
                    <span className="section-label">{g.cat}</span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
